"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APLabelWithText = _interopRequireDefault(require("../../../../common/APLabelWithText"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
require("./UserProfileStaticComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('user-profile-form-static');
var UserProfileStaticComponent = function UserProfileStaticComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var showUsernameField = props.showUsernameField,
    userInfo = props.userInfo;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, showUsernameField && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Username"),
    text: userInfo.username,
    customClass: classes()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t("Email"),
    text: userInfo.email,
    customClass: classes()
  })));
};
UserProfileStaticComponent.propTypes = {
  userInfo: _propTypes["default"].object,
  showUsernameField: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = UserProfileStaticComponent;